export const SERVICE_OPTIONS = [
  {
    path: "blood-cholesterol-checks",
    value: "blood and cholesterol checks",
    title: "Blood and cholesterol checks",
    description:
      "Personal details, blood pressure, pulse and cholesterol only.",
  },
  {
    path: "full-health-screen",
    value: "full health screen",
    title: "Full health screen",
    description: "The complete screening form for a full assessment.",
  },
  {
    path: "nurse-chat",
    value: "nurse chat",
    title: "Nurse chat",
    description: "A conversation-only appointment without the screening flow.",
  },
];

export const getServiceTitle = (service) =>
  SERVICE_OPTIONS.find((option) => option.value === service)?.title || service;

export const getServicePath = (service) =>
  SERVICE_OPTIONS.find((option) => option.value === service)?.path ||
  "full-health-screen";

export const getServiceValueByPath = (path) =>
  SERVICE_OPTIONS.find((option) => option.path === path)?.value || "";
